import useRequireAuth from './use-require-auth'
import { useAuth } from './use-auth'

export default {
  useAuth,
  useRequireAuth,
}
